<script>
  import { VDataTable } from 'vuetify/lib'
  import designConfig from '../../../../config/design'

  export default {
    name: 'Table',
    extends: VDataTable,
    props: {
      gridItems: {
        type: Array,
        default: ()=>([])
      },
      totalCount: {
        type: Number,
        default: 0
      },
      itemsPerPageOptions: {
        type: Array,
        default: () => { return designConfig.gridOptions.itemsPerPageOptions }
      }
    },
    render: function (h) {
      return h(
        VDataTable,
        {
          attrs: this.$attrs,
          on: {
            ...this.$listeners,
          },
          props: {
            ...this.$options.propsData,
            items: this.gridItems,
            serverItemsLength: this.totalCount,
            footerProps: {
              itemsPerPageOptions: this.itemsPerPageOptions,
            },
          },
          scopedSlots: this.$scopedSlots,
        })
    },
  }
</script>
